import * as read_api from "./alan_api";
function serialize_collection_block($_collection_block: read_api.Ccollection_block) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_columns: Record<string, any>;
		switch ($_collection_block.properties.has_columns.state.name) {
			case 'no': {
				const $_no__has_columns__collection_block = $_collection_block.properties.has_columns.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_columns = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_columns__collection_block = $_collection_block.properties.has_columns.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["header"] = $_yes__has_columns__collection_block.properties.header;
				raw_data["next"] = serialize_collection_block($_yes__has_columns__collection_block.properties.next);
				raw_data["property"] = serialize_property_selection($_yes__has_columns__collection_block.properties.property);
				raw_has_columns = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_collection_block.properties.has_columns.state)
		}
		raw_data["has columns"] = [$_collection_block.properties.has_columns.state.name, raw_has_columns];
	}
	return raw_data;
}
function serialize_list_block($_list_block: read_api.Clist_block) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_columns: Record<string, any>;
		switch ($_list_block.properties.has_columns.state.name) {
			case 'no': {
				const $_no__has_columns__list_block = $_list_block.properties.has_columns.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_columns = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_columns__list_block = $_list_block.properties.has_columns.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["header"] = $_yes__has_columns__list_block.properties.header;
				raw_data["next"] = serialize_list_block($_yes__has_columns__list_block.properties.next);
				raw_data["property"] = $_yes__has_columns__list_block.properties.property.entry;
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_columns__list_block.properties.type.state.name) {
						case 'date': {
							const $_date__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'datetime': {
							const $_datetime__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'decimal': {
							const $_decimal__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["shift"] = $_decimal__type__yes.properties.shift.value;
							raw_type = raw_data
							break;
						}
						case 'number': {
							const $_number__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'text': {
							const $_text__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'time': {
							const $_time__type__yes = $_yes__has_columns__list_block.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_columns__list_block.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_columns__list_block.properties.type.state.name, raw_type];
				}
				raw_has_columns = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_list_block.properties.has_columns.state)
		}
		raw_data["has columns"] = [$_list_block.properties.has_columns.state.name, raw_has_columns];
	}
	return raw_data;
}
function serialize_property_selection($_property_selection: read_api.Cproperty_selection) {
	const raw_data: Record<string, any> = {};
	raw_data["property"] = $_property_selection.properties.property.entry;
	{
		let raw_type: Record<string, any>;
		switch ($_property_selection.properties.type.state.name) {
			case 'date': {
				const $_date__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'datetime': {
				const $_datetime__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'decimal': {
				const $_decimal__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["shift"] = $_decimal__type__property_selection.properties.shift.value;
				raw_type = raw_data
				break;
			}
			case 'join': {
				const $_join = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["separator"] = $_join.properties.separator;
				raw_data["value"] = serialize_property_selection($_join.properties.value);
				raw_type = raw_data
				break;
			}
			case 'number': {
				const $_number__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'state': {
				const $_state__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'text': {
				const $_text__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'time': {
				const $_time__type__property_selection = $_property_selection.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_property_selection.properties.type.state)
		}
		raw_data["type"] = [$_property_selection.properties.type.state.name, raw_type];
	}
	return raw_data;
}
export function serialize($_collection_query_to_table: read_api.Ccollection_query_to_table) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_collection_query_to_table.properties.type.state.name) {
			case 'acyclic graph list query': {
				const $_acyclic_graph_list_query = $_collection_query_to_table.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["columns"] = serialize_list_block($_acyclic_graph_list_query.properties.columns);
				raw_type = raw_data
				break;
			}
			case 'collection query': {
				const $_collection_query = $_collection_query_to_table.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["columns"] = serialize_collection_block($_collection_query.properties.columns);
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_collection_query_to_table.properties.type.state)
		}
		raw_data["type"] = [$_collection_query_to_table.properties.type.state.name, raw_type];
	}
	return raw_data;
}